import { FC, ReactNode } from 'react';

import { css } from '@emotion/react';
import { ToucanComponents, ToucanColors } from '@jointoucan/toucan-design';
import { useTheme } from '@mui/material';

import { Box } from '~/components/shared/Box';

const { Typography } = ToucanComponents;

interface InformationHeadersProps {
  information: string | ReactNode;
  maxWidth?: number;
  subInformation?: string;
  isStacked?: boolean;
}

export const InformationHeader: FC<InformationHeadersProps> = ({
  information,
  subInformation,
  children,
  isStacked,
  maxWidth,
}) => {
  const theme = useTheme();

  return (
    <Box>
      <Box
        display="inline-flex"
        flexDirection={isStacked ? 'column' : 'row'}
        flex={1}
        css={css`
          ${theme.breakpoints.up('sm')} {
            margin-right: ${theme.spacing(3)};
          }
        `}
      >
        <Typography
          variant="sm"
          isBold
          color={ToucanColors.gray[500]}
          css={css`
            margin-right: ${theme.spacing(1)};
          `}
        >
          {children}
        </Typography>
        <Typography
          variant="sm"
          color={ToucanColors.gray[500]}
          css={css`
            margin-top: ${isStacked ? theme.spacing(0.5) : 0};
            max-width: ${`${maxWidth}px` || 'none'};
          `}
        >
          {information}
        </Typography>
      </Box>
      {subInformation && (
        <Typography
          variant="xs"
          color={ToucanColors.gray[400]}
          css={css`
            margin-right: ${theme.spacing(1)};
          `}
        >
          {subInformation}
        </Typography>
      )}
    </Box>
  );
};
